import { render } from "./subTopicRelease.vue?vue&type=template&id=49876c95&scoped=true"
import script from "./subTopicRelease.vue?vue&type=script&lang=js"
export * from "./subTopicRelease.vue?vue&type=script&lang=js"

import "./subTopicRelease.vue?vue&type=style&index=0&id=49876c95&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49876c95"]])

export default __exports__